<template>
  <div>
    <label
      for="avatar"
      class="hidden mb-1 ml-2 px-0.5 text-sm font-medium select-none"
      >Circle Suggestions
    </label>

    <div class="flex flex-col items-center space-y-2">
      <template v-if="suggestedUsers === null">
        <div class="text-center">
          <fa-icon icon="spinner-third" spin class="text-gray-800" />
          <h3 class="mt-2 text-sm font-semibold text-gray-900">Loading</h3>
          <p class="mt-1 text-sm italic text-gray-700">
            Checking who's got great taste...
          </p>
        </div>
      </template>
      <template v-else-if="suggestedUsers.length === 0">
        <div class="text-center">
          <fa-icon
            :icon="['far', 'face-meh']"
            class="mx-auto w-12 h-12 text-gray-800" />
          <h3 class="mt-2 text-sm font-semibold text-gray-900">So lonely</h3>
          <p class="mt-1 text-sm italic text-gray-700">
            We don't have any user suggestions for you at the moment.
          </p>
        </div>
      </template>
      <ul v-else class="grid grid-cols-1 gap-3 w-full">
        <template v-for="user in suggestedUsers.slice(0, 3)" :key="user.id">
          <li class="relative">
            <PersonListCard :user="user" />
          </li>
        </template>
      </ul>

      <div
        v-if="suggestedUsers && suggestedUsers.length > 3"
        class="mt-4 text-center">
        <p class="text-xs text-white/80">
          {{ suggestedUsers.length - 3 }} more suggestions available after setup
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useStoreProfile } from '@/stores/storeProfile'
import { useStoreUsers } from '@/stores/storeUsers'
import PersonListCard from '@/components/PersonListCard.vue'

const storeProfile = useStoreProfile()
const storeUsers = useStoreUsers()
const props = defineProps({
  profile: Object
})
const suggestedUsers = ref(null)

onMounted(() => {
  storeUsers.fetchSuggestedUsers().then((users) => {
    suggestedUsers.value = users
  })
})
</script>
